// languages.ts
var Languages = /* @__PURE__ */ ((Languages2) => {
  Languages2["ARABIC"] = "ar";
  Languages2["CZECH"] = "cs";
  Languages2["GERMAN"] = "de";
  Languages2["GREEK"] = "el";
  Languages2["ENGLISH"] = "en";
  Languages2["SPANISH"] = "es";
  Languages2["PERSIAN"] = "fa";
  Languages2["FRENCH"] = "fr";
  Languages2["HEBREW"] = "he";
  Languages2["HUNGARIAN"] = "hu";
  Languages2["INDONESIAN"] = "id";
  Languages2["ITALIAN"] = "it";
  Languages2["JAPANESE"] = "ja";
  Languages2["KOREAN"] = "ko";
  Languages2["MALAGASY"] = "mg";
  Languages2["MALAYALAM"] = "ml";
  Languages2["DUTCH"] = "nl";
  Languages2["PORTUGUESE"] = "pt";
  Languages2["RUSSIAN"] = "ru";
  Languages2["SWEDISH"] = "sv";
  Languages2["TURKISH"] = "tr";
  Languages2["UKRAINIAN"] = "uk";
  Languages2["CHINESE"] = "zh";
  return Languages2;
})(Languages || {});
export {
  Languages
};
